import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Store reference - will be injected to avoid circular dependency
let storeRef = null;

// Function to inject the store after it's created
export const injectStore = (store) => {
  storeRef = store;
};

// Request interceptor - add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If 401 and not already retrying
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        try {
          const response = await axios.post(
            `${import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api'}/auth/refresh`,
            { refreshToken }
          );

          const { accessToken } = response.data.data;

          // Update localStorage
          localStorage.setItem('accessToken', accessToken);

          // Dispatch to store if available
          if (storeRef) {
            const { setTokens } = await import('../store/slices/authSlice');
            storeRef.dispatch(setTokens({ accessToken }));
          }

          originalRequest.headers.Authorization = `Bearer ${accessToken}`;
          return api(originalRequest);
        } catch (refreshError) {
          // Refresh failed - logout
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');

          if (storeRef) {
            const { logout } = await import('../store/slices/authSlice');
            storeRef.dispatch(logout());
          }

          window.location.href = '/login';
          return Promise.reject(refreshError);
        }
      } else {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');

        if (storeRef) {
          const { logout } = await import('../store/slices/authSlice');
          storeRef.dispatch(logout());
        }

        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
